require('./src/fonts/ew-font.css');

function addExtole() {
  // This adds everything extole needs so Refer a Friend works in the footer
  const script = document.createElement('script');
  const div = document.createElement('div');

  script.src = 'https://everlywell.extole.io/core.js';
  div.id = 'extole_zone_new_results_nav_bar';

  document.body.appendChild(script);
  document.body.appendChild(div);
}

function addModal() {
  // add div for app modals
  const div = document.createElement('div');
  div.id = 'modal';
  document.body.appendChild(div);
}

function addSolvvy() {
  // This adds everything extole needs so Refer a Friend works in the footer
  const script = document.createElement('script');

  script.src =
    'https://cdn.solvvy.com/deflect/customization/everlywell/solvvy.js';
  script.async = 'true';

  document.head.appendChild(script);
}

exports.onInitialClientRender = () => {
  addModal();
  addExtole();
  addSolvvy();
};
